var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 3h8.25A1.5 1.5 0 0 1 21 4.5v8.25a1.5 1.5 0 0 1-1.5 1.5h-3.75v1.5h3.75a3 3 0 0 0 3-3V4.5a3 3 0 0 0-3-3h-8.25a3 3 0 0 0-3 3v3.75h1.5V4.5a1.5 1.5 0 0 1 1.5-1.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 9.75H4.5a1.5 1.5 0 0 0-1.5 1.5v8.25A1.5 1.5 0 0 0 4.5 21h8.25a1.5 1.5 0 0 0 1.5-1.5v-8.25a1.5 1.5 0 0 0-1.5-1.5ZM4.5 8.25a3 3 0 0 0-3 3v8.25a3 3 0 0 0 3 3h8.25a3 3 0 0 0 3-3v-8.25a3 3 0 0 0-3-3H4.5Z"
  })));
};

export default SvgCopy;